/**
 * A Canva design whose product could not be resolved (no matching SKU, or several) is parked in
 * the backend and the buyer is sent to the company gallery with {@code ?canvaDraftId=}. Picking a
 * SKU there finishes that publish instead of starting an empty job config.
 */
const CANVA_DRAFT_PARAM = 'canvaDraftId';

/** Reads the parked-design id off a location search string; undefined when the visit is a normal one. */
export const parseCanvaPublishDraftId = (search: string): string | undefined => {
  const draftId = new URLSearchParams(search).get(CANVA_DRAFT_PARAM)?.trim();
  return draftId ? draftId : undefined;
};
